import { Block } from 'webiq.boilerplate'

export default class ShoppingcartOption extends Block {
	static title = 'shoppingcart-option'

	init() {
		if (this.hasModifier('apple-pay')) {
			if (
				'ApplePaySession' in window === false ||
				!window.ApplePaySession.canMakePayments()
			) {
				this.element.closest('.grid__col').remove()
			}
		}
	}
}
